export const production_url = 'https://ark-api-template-staging.proof-point-suite.com/api'